import React from 'react';

export default function ({ highlightsfeed, eleRef }) {

  
  return (
      <div>
      {highlightsfeed.userData ? 
      <section className="main_container_block_feeds">
          <div className="main_block_container_feed">
             <div className="block_container_feed_heading_text R15_61">
                {highlightsfeed.title?highlightsfeed.title:''}
              </div>
              <div className="content-div-box-artical">
                  <div className="content-div_view_artical">
                    <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/kick_counter_view.jpeg" alt="logo"/>
                  </div>
                  
                      <div className="baby_kick_counter_might_join"> 
                        <div className="common_kick_countr_view1">
                         <div className="kick_counter_track_first"> 
                             <div className="kick_track_left count_text_1"> 
                              <div className="date_time_kick R13_white"> Date & Time </div>
                              <div className="date_time_kick_nu B14_white"> {highlightsfeed.userData[0] && highlightsfeed.userData[0]["date"]? highlightsfeed.userData[0]["date"]:''} {highlightsfeed.userData[0] && highlightsfeed.userData[0]["start_time"]? highlightsfeed.userData[0]["start_time"]:''} </div>
                             </div>
                             <div className="kick_track_left count_text_2"> 
                              <div className="date_time_kick R13_white"> Kick </div>
                              <div className="date_time_kick_nu B14_white"> {highlightsfeed.userData[0] && highlightsfeed.userData[0]["kick_count"] ? highlightsfeed.userData[0]["kick_count"]:'0'} </div>
                             </div>
                             <div className="kick_track_left count_text_3"> 
                              <div className="date_time_kick R13_white"> Duration </div>
                              <div className="date_time_kick_nu B14_white"> {highlightsfeed.userData[0] && highlightsfeed.userData[0]["duration"] ? highlightsfeed.userData[0]["duration"]:'0'} </div>
                             </div>
                          </div>
                          <div className="btn_group_join_common kick_counter_common_btn">
                          <a href={(highlightsfeed.data)?highlightsfeed.data[0].redirectionUrl:''} >
                            <button className="M16_white text_uppercase gtm-kick-button" type="button"> {highlightsfeed.data[0].buttonText}</button>
                            </a>
                          </div>
                      </div>
                      </div>
                  </div>
              </div>
          </section> : <div>
            {highlightsfeed.data && 
              <section className="main_container_block_feeds">
              <div className="main_block_container_feed">
                 <div className="block_container_feed_heading_text R15_61">
                    Start recording your <span className="dny-b-15">{highlightsfeed.title?highlightsfeed.title:''}</span>
                  </div>
                  <div className="content-div-box-artical">
                      <div className="content-div_view_artical">
                      <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/kick_counter_view.jpeg" alt="logo"/>
                      
                      {/* {highlightsfeed.dataApp[0].imageUrl && highlightsfeed.dataApp[0].imageUrl!="" ?
                        <img src={highlightsfeed.dataApp[0].imageUrl} alt="logo"/> :
                        <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/kick_counter_view.jpeg" alt="logo"/>
                      } */}
                      </div>
                      
                          <div className="baby_kick_counter_might_join"> 
                            <div className="common_kick_countr_view1">
                             <div className="kick_counter_track_first fc_pd_12_20"> 
                                
                                  <div className="my_baby_question_ask"> 
                                      <span className="my_baby_question_disc R16_white"> 
                                        {highlightsfeed.dataApp[0].descriptionText}
                                      </span>
                                  </div>
                                  <a href="https://parenting.firstcry.com/tools/fetal-movement-tracker/" className="readmorelink opacity_t R14_white"> Read more</a> 
                              </div>
                              <div className="btn_group_join_common kick_counter_common_btn">
                                 <a href={(highlightsfeed.data)?highlightsfeed.dataApp[0].redirectionUrl:''} >
                                      <button className="M16_white text_uppercase gtm-kick-button" type="button">{highlightsfeed.dataApp[0].buttonText}</button>
                                  </a>
                              </div>
                          </div>
                          </div>
                      </div>
                  </div>
              </section> } </div>
 } </div>

    )
}
